(function () {
	function ready(fn) {
		if (document.readyState !== 'loading') {
			fn();
		} else {
			document.addEventListener('DOMContentLoaded', fn);
		}
	}

	function removeClamp(container, content, button) {
		container.classList.remove('clamp-container');
		content.classList.remove('clamp-container__content');

		container.style.maxHeight = 'none';
		container.style.overflow = 'visible';

		button.remove();
	}

	function toggleClamp(container, content, button) {
		var isOpen = button.getAttribute('aria-expanded') === 'true';
		console.log('isOpen', isOpen)
		if(isOpen) {
			container.classList.remove('clamp-container--expanded');

			button.innerText = 'Read more';

			button.setAttribute('aria-expanded', 'false');
		} else {
			container.classList.add('clamp-container--expanded');

			button.innerText = 'Read less';

			 button.setAttribute('aria-expanded', 'true');
		}

	}

	ready(function () {
		document.querySelectorAll('.clamp-container').forEach(function (container) {

			var button = container.querySelector('.clamp-container__button');
			var content = container.querySelector('.clamp-container__content');

			if (content.scrollHeight <= content.clientHeight) {
				// No overflow: hide gradient + button
				removeClamp(container, content, button);
				return;
			}

			button.addEventListener('click', function () {
				toggleClamp(container, content, button);
			});
		})
	});

})();
